import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { saveAs } from "file-saver";
import snakeCase from "lodash.snakecase";
import { Dialog, InputAdornment, TextField, Typography } from "@mui/material";
import { projectDataPropType } from "../util/propTypeHelper";
import { STEP_STORAGE_KEYS } from "../constants/storageConstants";
import CloseButton from "./CloseButton";

export default function FilenameFormDialog({ onClose, projectData }) {
  const [projectName, setProjectName] = useState(
    projectData[STEP_STORAGE_KEYS.PROJECT_INFORMATION]?.projectName
  );
  const saveProjectToFile = () => {
    const blob = new Blob([JSON.stringify(projectData)], {
      type: "application/json",
    });
    saveAs(blob, `${snakeCase(projectName)}.json`);
    return onClose();
  };

  return (
    <Dialog onClose={onClose} open>
      <div style={{ padding: "50px 70px", position: "relative" }}>
        <CloseButton onClick={onClose} />
        <Typography variant="h5" sx={{ marginBottom: "40px" }}>
          Export Analysis
        </Typography>
        <Typography sx={{ marginBottom: "40px" }}>
          Save all project data to a .json file. Anyone can upload this file on
          the{" "}
          <a
            href={process.env.PUBLIC_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Penn DOT ICE homepage
          </a>{" "}
          to resume the analysis. Data is only saved to the file, not to this
          website.
        </Typography>
        <TextField
          defaultValue={projectName}
          InputProps={{
            endAdornment: <InputAdornment position="end">.json</InputAdornment>,
          }}
          label="File Name"
          onChange={(e) => setProjectName(e.target.value)}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <Button
            variant="contained"
            color="success"
            onClick={saveProjectToFile}
          >
            Export
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

FilenameFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  projectData: projectDataPropType.isRequired,
};
